import React from 'react';
import { Box, Typography } from '@mui/material';
import { StyledButton } from '../../styles/StyledButtons';
import { AdminAssistDraft } from './veraAdminChatAssistPromptSandboxUtils';

interface AdminAssistDraftBannerProps {
  savedDraft: AdminAssistDraft;
  onRestore: (draft: AdminAssistDraft) => void;
  onDismiss: () => void;
}

export default function AdminAssistDraftBanner({
  savedDraft,
  onRestore,
  onDismiss,
}: AdminAssistDraftBannerProps) {
  return (
    <Box
      sx={{
        mb: 2,
        p: 2,
        border: '1px solid',
        borderColor: 'warning.main',
        borderRadius: 1,
        background: 'rgba(255,160,0,0.06)',
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        flexWrap: 'wrap',
      }}
    >
      <Typography variant="body2" sx={{ flex: 1 }}>
        Resume admin assist draft from{' '}
        <strong>{new Date(savedDraft.savedAt).toLocaleString()}</strong>
        {savedDraft.contactLabel ? ` — ${savedDraft.contactLabel}` : ''}
      </Typography>
      <StyledButton size="small" onClick={() => onRestore(savedDraft)}>
        Resume
      </StyledButton>
      <StyledButton size="small" variant="outlined" onClick={onDismiss}>
        Discard
      </StyledButton>
    </Box>
  );
}
